var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBluebg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 720,
    height: 498,
    viewBox: "0 0 720 498",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M426.755 -378.339C526.01 -373.623 630.416 -336.737 691.019 -259.942C747.053 -188.936 709.403 -88.1116 725.408 0.114166C738.276 71.0439 786.302 133.961 775.404 205.204C763.332 284.132 724.842 359.453 662.532 411.186C597.271 465.368 510.835 510.895 426.755 494.671C345.261 478.947 319.875 375.823 250.249 331.635C174.069 283.287 41.2528 309.785 6.43092 227.913C-27.6816 147.71 83.9568 77.257 106.308 -6.79071C131.067 -99.8916 79.6084 -212.367 143.094 -285.976C208.865 -362.236 324.689 -383.189 426.755 -378.339Z",
    fill: "#060073"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluebg);
export default __webpack_public_path__ + "static/media/bluebg.8ea1764b7411cea44dd20e0acf4bf3f9.svg";
export { ForwardRef as ReactComponent };